export default __webpack_public_path__ + "static/media/Img1.9a9fe35d.jpg";